import { motion } from "framer-motion";
import { Bot, User, Sparkles, Send } from "lucide-react";

/**
 * Static capture simulating the AI Chat Assistant interface
 * Used in the "Assistant Botanique" feature section
 */
const FeatureChatCapture = () => {
  return (
    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-4 shadow-lg border border-emerald-200">
      {/* Chat Header */}
      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-emerald-200">
        <div className="w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center">
          <Bot className="w-4 h-4 text-white" />
        </div>
        <div>
          <span className="text-[11px] font-semibold text-slate-800 block">CynthIA</span>
          <span className="text-[9px] text-emerald-600 flex items-center gap-1">
            <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
            En ligne
          </span>
        </div>
        <Sparkles className="w-3.5 h-3.5 text-emerald-500 ml-auto" />
      </div>

      {/* Chat Messages */}
      <div className="space-y-2 mb-3">
        {/* User message */}
        <motion.div
          className="flex justify-end"
          initial={{ opacity: 0, x: 10 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <div className="bg-emerald-600 text-white rounded-2xl rounded-tr-sm px-3 py-2 max-w-[80%]">
            <p className="text-[10px] leading-relaxed">Quand dois-je tailler mes rosiers ?</p>
          </div>
        </motion.div>

        {/* AI response */}
        <motion.div
          className="flex gap-2"
          initial={{ opacity: 0, x: -10 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
            <Bot className="w-3 h-3 text-emerald-600" />
          </div>
          <div className="bg-white rounded-2xl rounded-tl-sm px-3 py-2 shadow-sm border border-slate-100 max-w-[85%]">
            <p className="text-[10px] text-slate-700 leading-relaxed">
              Pour vos rosiers en <strong>zone tempérée</strong>, la taille principale se fait en{" "}
              <strong>février-mars</strong>. Vu les données de vos capteurs, je recommande d'attendre encore 2 semaines.
              🌹
            </p>
          </div>
        </motion.div>
      </div>

      {/* Input simulation */}
      <div className="flex items-center gap-2 bg-white rounded-full px-3 py-2 border border-slate-200 shadow-sm">
        <span className="text-[10px] text-slate-400 flex-1">Posez votre question...</span>
        <div className="w-6 h-6 rounded-full bg-emerald-600 flex items-center justify-center">
          <Send className="w-3 h-3 text-white" />
        </div>
      </div>
    </div>
  );
};

export default FeatureChatCapture;
